import { generateUUID } from 'shared/helpers/utils/generate-uuid';
import { TableFilterFieldType } from 'common/TableFilter';
import type { TableFilterField } from 'common/TableFilter';

export const teacherWorkloadsFilterFields: TableFilterField[] = [
  {
    key: generateUUID(),
    name: 'code',
    label: 'Код преподавателя',
    type: TableFilterFieldType.INPUT,
  },
  {
    key: generateUUID(),
    name: 'preferredRoomIds',
    label: 'Аудитория преподавателя',
    type: TableFilterFieldType.MULTI_SELECT,
    isLoadableOptions: true,
  },
  {
    key: generateUUID(),
    name: 'subjectIds',
    label: 'Предметы',
    type: TableFilterFieldType.MULTI_SELECT,
    isLoadableOptions: true,
  },
  {
    key: generateUUID(),
    name: 'educationClassIds',
    label: 'Классы',
    type: TableFilterFieldType.MULTI_SELECT,
  },
];
